import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getDepositAccountsV2 } from 'services/WalletsService'
import { BankAccountsDetails } from 'types/BankAccountsDetails'
import { BaseErrorResponse } from 'types/beneficiaries'
import { ErrorAPI } from 'types/types'

export const useDepositAccountsV2Query = (walletId: string, enabled = false) => {
  return useQuery<BankAccountsDetails, { data: ErrorAPI }>(
    reactQueryKeys.depositAccountsV2(walletId),
    () => getDepositAccountsV2(walletId),
    {
      onError: (error: BaseErrorResponse) => {
        logSentryError('Error from useDepositAccountsV2Query', error, {
          walletId,
        })
      },
      enabled,
      retry: false,
    }
  )
}
